module.exports = __webpack_public_path__ + "static/wpack/extracted/news-edsurgee45ea8ceeeb379705376c413dee14f2c.png";